import React from "react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0f1114] text-zinc-300 p-8 max-w-3xl mx-auto">
      <h1 className="font-display text-3xl font-bold text-zinc-100 mb-6">Privacy Policy</h1>
      <p className="text-xs text-zinc-500 mb-8">Last updated: March 15, 2026</p>

      <div className="space-y-6 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-zinc-100 mb-2">Overview</h2>
          <p>CommandPost is a private, internal business management tool operated by Ryan Geldermann. It is not a public-facing application and does not collect data from external users.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-zinc-100 mb-2">Data Collection</h2>
          <p>CommandPost connects to third-party APIs (Meta, Vimeo, YouTube, Google, Dropbox) to manage social media content and advertising for businesses owned by the operator. All data accessed through these APIs is used solely for internal business management purposes.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-zinc-100 mb-2">Data Storage</h2>
          <p>Data is stored securely in encrypted databases (MongoDB Atlas) and cloud storage (Cloudflare R2). Access is restricted to the single authenticated user of the application.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-zinc-100 mb-2">Data Sharing</h2>
          <p>No personal data or platform data is shared with third parties, sold, or used for any purpose other than managing the business owner's own accounts and content.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-zinc-100 mb-2">Data Deletion</h2>
          <p>To request deletion of any data associated with this application, contact the operator directly. All platform data can be removed from the database upon request.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-zinc-100 mb-2">Contact</h2>
          <p>For any privacy-related inquiries, contact the application operator at the email address associated with this business.</p>
        </section>
      </div>
    </div>
  );
}
